import { atom } from "recoil";

/** Saved cards from billing API; SavedCards writes, InvoiceTable (and others) read. */
export const billingSavedCardsState = atom({
  key: "billingSavedCardsState",
  default: {
    list: [],
    loading: true,
  },
});
